import { render, staticRenderFns } from "./ModeratorYearlyTab.vue?vue&type=template&id=436db87e&"
import script from "./ModeratorYearlyTab.vue?vue&type=script&lang=js&"
export * from "./ModeratorYearlyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports